import React from "react";
import cn from "classnames";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import styles from "./PhoneInput.module.sass";
import Tooltip from "../Tooltip";
import Icon from "../Icon";

const CustomPhoneInput = ({
  className,
  classLabel,
  label,
  value,
  onChange,
  placeholder,
  name,
  tooltip,
  required,
  disabled,
  error,
  success,
  preferredCountries = ['fr', 'be', 'ch', 'lu', 'mc'],
  defaultCountry = "fr"
}) => {
  // Ensure phone value is properly formatted
  const formattedValue = value && typeof value === 'string' && value.trim() !== '' ? value : '';
  return (
    <div
      className={cn(
        styles.field,
        { [styles.error]: error },
        { [styles.success]: success },
        className
      )}
    >
      {label && (
        <div className={cn(styles.label, classLabel)}>
          {label}
          {required && <span className={styles.required}>*</span>}{" "}
          {tooltip && (
            <Tooltip
              className={styles.tooltip}
              title={tooltip}
              icon="info"
              place="right"
            />
          )}
        </div>
      )}
      <div className={styles.phoneInputWrapper}>
        <PhoneInput
          country={defaultCountry}
          value={formattedValue}
          onChange={(phone) => onChange({ target: { name, value: phone } })}
          placeholder={placeholder || "Numéro de téléphone"}
          inputClass={styles.phoneInputField}
          buttonClass={styles.phoneInputButton}
          dropdownClass={styles.phoneInputDropdown}
          disabled={disabled}
          enableSearch={false}
          disableSearchIcon={true}
          specialLabel=""
          preferredCountries={preferredCountries}
          enableAreaCodes={false}
          autoFormat={true}
          countryCodeEditable={false}
          enableLongNumbers={true}
          containerStyle={{ width: "100%" }}
          inputStyle={{ width: "100%" }}
          dropdownStyle={{ zIndex: 9999, width: "300px" }}
          onlyCountries={['at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se']}
          localization={{
            fr: "France",
            be: "Belgique",
            ch: "Suisse",
            lu: "Luxembourg",
            ca: "Canada",
            mc: "Monaco",
            dz: "Algérie",
            ma: "Maroc",
            tn: "Tunisie",
            sn: "Sénégal",
            ci: "Côte d'Ivoire",
            ml: "Mali"
          }}
        />
      </div>
      {error && (
        <div className={styles.errorMessage}>
          <Icon name="error" size="14" />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default CustomPhoneInput;
